var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75308 2.01591C8.98883 1.88499 9.25405 1.81628 9.52372 1.81628C9.79338 1.81628 10.0586 1.88499 10.2944 2.01591L16.2586 5.32861C16.3823 5.39737 16.4853 5.49794 16.557 5.6199C16.6288 5.74186 16.6666 5.88077 16.6666 6.02226V12.558C16.6665 12.841 16.5908 13.1189 16.4472 13.3628C16.3036 13.6068 16.0974 13.8079 15.8499 13.9453L10.2944 17.0326C10.0586 17.1635 9.79338 17.2322 9.52372 17.2322C9.25405 17.2322 8.98883 17.1635 8.75308 17.0326L3.19753 13.9453C2.95019 13.8079 2.74406 13.607 2.60047 13.3632C2.45689 13.1194 2.38107 12.8417 2.38086 12.5588V6.02226C2.38085 5.88077 2.41867 5.74186 2.4904 5.6199C2.56212 5.49794 2.66514 5.39737 2.7888 5.32861L8.75308 2.01591Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38086 5.55554L9.52372 9.5238M9.52372 9.5238L16.6666 5.55554M9.52372 9.5238V17.0635",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95215 7.53966L13.095 3.57141",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76172 9.78418L7.14267 11.1112",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.d7786baf13a0e60588715b7284f17f16.svg";
export { ForwardRef as ReactComponent };